import React, { useEffect, useState } from "react";
import RedirectToExternalBrowser from "./RedirectToExternalBrowser";

import "./newApp.css";
import "typeface-roboto";
import "typeface-poppins";
import SearchIcon from "@mui/icons-material/Search";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Button } from "@mui/material";
import ShareIcon from "@mui/icons-material/Share";
import StarIcon from "@mui/icons-material/Star";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import TabletAndroidIcon from "@mui/icons-material/TabletAndroid";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import googlePlayLogo from "./assets/google-play-logo.png";
import icon from "./assets/icon.png";
import screenshot1 from "./assets/1.png";
import screenshot2 from "./assets/2.png";
import screenshot3 from "./assets/3.png";
import screenshot4 from "./assets/4.png";
import screenshot5 from "./assets/5.png";
import dataImage from "./assets/data.png";
import deleteImage from "./assets/delete.png";
import ShareImage from "./assets/share.png";
import userImage1 from "./assets/u1.png";
import userImage2 from "./assets/u2.png";
import userImage3 from "./assets/u3.png";
import greenStar from "./assets/green-start.png";
import whiteStar from "./assets/white-star.png";
const staticDunImage = require("./assets/static-dun.png");
const eighteenPlusImage = require("./assets/18Plus.png");

function App() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [appInstalled, setAppInstalled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showOpenButton, setShowOpenButton] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isTelegramInAppBrowser = userAgent.includes("Telegram");

    if (isTelegramInAppBrowser) {
      // Redirect to the same URL, which will open in the default browser
      window.location.href = window.location.href;
    }
  }, []);

  useEffect(() => {
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone;
    if (isStandalone) {
      setAppInstalled(true);
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      // console.log("beforeinstallprompt event captured");
    };

    window.addEventListener("beforeinstallprompt", handler);
    window.addEventListener("appinstalled", () => {
      // console.log("PWA was installed");
      setDeferredPrompt(null);
      setAppInstalled(true);
    });

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
    };
  }, []);

  const DownSoft = () => {
    // console.log("DownSoft function called");
  };

  const ratingReviewStyle = {
    marginLeft: windowWidth <= 768 ? "20px" : "50px",
    marginRight: windowWidth <= 768 ? "20px" : "500px",
    maxWidth: windowWidth <= 768 ? "100%" : "1200px",
  };

  const handleLinkClick = (event) => {
    event.preventDefault();
    DownSoft();
  };

  const handleDownloadClick = () => {
    setLoading(true);
    // console.log("App is downloading...");
    // Increased timeout for better handling of slower loading times
    setTimeout(() => {
      setLoading(false);
      setIsReady(true);
    }, 20000); // Increased timeout duration to 20000ms
  };

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          // console.log("User accepted the install prompt");
          // Increased timeout to allow time for the app to be installed and loaded
          setTimeout(() => {
            setShowOpenButton(true);
          }, 20000); // Adjusted to give more time for the installation process
        } else {
          // console.log("User dismissed the install prompt");
        }
        setDeferredPrompt(null);
      });
    }
  };

  const sharePage = () => {
    if (navigator.share) {
      navigator
        .share({
          title: document.title,
          text: "Check out this app!",
          url: window.location.href,
        })
        .then(() => {
          // console.log("Thanks for sharing!");
        })
        .catch((error) => {
          // console.log("Error sharing", error);
        });
    } else {
      const textArea = document.createElement("textarea");
      textArea.value = window.location.href;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      alert("URL copied to clipboard");
    }
  };

  return (
    <div>
      <RedirectToExternalBrowser />

      {appInstalled ? (
        <iframe
          src="https://visionaries-all.s3.ap-northeast-3.amazonaws.com/app/Visionaries+X.html"
          title="Visionaries X"
          style={{ width: "100%", height: "100vh", border: "none" }}
        ></iframe>
      ) : (
        <div className="SSPGKf Czez9d" style={{ padding: "20px" }}>
          <header className="S3WLMd" role="banner">
            <nav className="oPjgQb">
              <a className="f0UV3d" href="#!" onClick={handleLinkClick}>
                <img
                  style={{ marginRight: "8px", height: "45px" }}
                  src={googlePlayLogo}
                  alt="Google Play Logo"
                />
              </a>
              <div className="oc9n0c">
                <div>
                  <button className="VfPpkd-Bz112c-LgbsSe yHy1rc eT1oJ mN1ivc">
                    <SearchIcon />
                  </button>
                </div>
                <div>
                  <button className="VfPpkd-Bz112c-LgbsSe yHy1rc eT1oJ QDwDD mN1ivc">
                    <HelpOutlineIcon />
                  </button>
                </div>
              </div>
            </nav>
            <c-wiz autoUpdate="" c-wiz="">
              <div className="P7NFWb">
                <nav className="yyaGpb">
                  <a
                    className="uEz1ib Y4jiDf"
                    href="#!"
                    onClick={handleLinkClick}
                  >
                    <div className="jb05Ib">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 21 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M19.3 8.4C19.2169 7.65213 19.0648 6.90427 18.9009 6.09902C18.8676 5.93522 18.8338 5.76904 18.8 5.6L18.8 5.59986C18.7 5.1 18.7 5.09996 18.6 4.7L18.5 4.4C18.2 1.8 16 0 13.3 0H6.7C4.1 0 1.8 1.8 1.4 4.4C1.4 4.43174 1.4 4.4534 1.3968 4.47458C1.38993 4.52014 1.36826 4.56347 1.3 4.7C1.3 5.1 1.3 5.1 1.2 5.6C1.1 6.05 1.025 6.525 0.95 7C0.875 7.475 0.8 7.95 0.7 8.4C0.1 11.9 0 12.5 0 12.7C0 14.2 1.2 15.5 2.8 15.5C3.6 15.5 4.3 15.2 4.8 14.7L7.7 11.9H12.4L15.3 14.8C15.8 15.3 16.5 15.6 17.3 15.6C18.8 15.6 20.1 14.4 20.1 12.8C20.0055 12.5165 19.911 11.9651 19.3946 8.95177L19.3 8.4ZM13 5C13.4971 5 13.9 4.59706 13.9 4.1C13.9 3.60294 13.4971 3.2 13 3.2C12.5029 3.2 12.1 3.60294 12.1 4.1C12.1 4.59706 12.5029 5 13 5ZM15.8 6C15.8 6.49706 15.3971 6.9 14.9 6.9C14.4029 6.9 14 6.49706 14 6C14 5.50294 14.4029 5.1 14.9 5.1C15.3971 5.1 15.8 5.50294 15.8 6ZM10.5 5.4C10.2 5.7 10.2 6.3 10.5 6.6C10.8 6.9 11.4 6.9 11.7 6.6C12 6.3 12 5.7 11.7 5.4C11.4 5.1 10.9 5.1 10.5 5.4ZM13 8.8C13.4971 8.8 13.9 8.39706 13.9 7.9C13.9 7.40294 13.4971 7 13 7C12.5029 7 12.1 7.40294 12.1 7.9C12.1 8.39706 12.5029 8.8 13 8.8ZM6.4 3.5H7.6V5.4H9.5V6.6H7.6V8.5H6.4V6.6H4.5V5.4H6.4V3.5ZM16.5 13.3C16.7 13.5 16.9 13.6 17.2 13.6C17.8 13.6 18.2 13.2 18.2 12.6C18.2 12.7 16.8 4.8 16.8 4.7C16.5 3 15 1.8 13.3 1.8H6.7C4.9 1.8 3.5 3 3.2 4.7C3.2 4.8 1.8 12.7 1.8 12.7C1.8 13.3 2.3 13.7 2.8 13.7C3.1 13.7 3.3 13.6 3.5 13.4L6.9 10H13.1L13.4 10.2L16.5 13.3Z"
                          fill="#5F6368"
                        />
                      </svg>
                    </div>
                    <div className="WL3b7c">Games</div>
                  </a>
                  <a
                    className="uEz1ib VuUAje"
                    href="#!"
                    onClick={handleLinkClick}
                  >
                    <div className="jb05Ib">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="VuUAje"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M15 4H18C19.1 4 20 4.9 20 6V9C20 10.1 19.1 11 18 11H15C13.9 11 13 10.1 13 9V6C13 4.9 13.9 4 15 4ZM9 13H6C4.9 13 4 13.9 4 15V18C4 19.1 4.9 20 6 20H9C10.1 20 11 19.1 11 18V15C11 13.9 10.1 13 9 13ZM18 13H15C13.9 13 13 13.9 13 15V18C13 19.1 13.9 20 15 20H18C19.1 20 20 19.1 20 18V15C20 13.9 19.1 13 18 13ZM9 4H6C4.9 4 4 4.9 4 6V9C4 10.1 4.9 11 6 11H9C10.1 11 11 10.1 11 9V6C11 4.9 10.1 4 9 4Z"
                        />
                      </svg>
                    </div>
                    <div className="WL3b7c">Apps</div>
                  </a>
                  <a
                    className="uEz1ib Y4jiDf"
                    href="#!"
                    onClick={handleLinkClick}
                  >
                    <div className="jb05Ib">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M3 2V22H21V2H3ZM5 20H19V4H5V20ZM9 7H6V5H9V7ZM18 7H15V5H18V7ZM6 19H9V17H6V19ZM18 19H15V17H18V19ZM15 15H18V13H15V15ZM9 15H6V13H9V15ZM15 11H18V9H15V11ZM9 11H6V9H9V11Z"
                        />
                      </svg>
                    </div>
                    <div className="WL3b7c">Films</div>
                  </a>
                  <a
                    className="uEz1ib Y4jiDf"
                    href="#!"
                    onClick={handleLinkClick}
                  >
                    <div className="jb05Ib">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M12.4996 6.36584L14.001 7.65237V4H11.001V7.65075L12.4996 6.36584ZM10 2H11.001H14.001H15H16.998C18.6461 2 20.001 3.35397 20.001 5.002V18.998C20.001 20.646 18.6461 22 16.998 22H4V2H10ZM18.001 5.002C18.001 4.459 17.542 4 16.998 4H16.001V12L12.5 9L9.001 12V4H6V20H16.998C17.542 20 18.001 19.541 18.001 18.998V5.002Z"
                        />
                      </svg>
                    </div>
                    <div className="WL3b7c">Books</div>
                  </a>
                  <a
                    className="uEz1ib Y4jiDf"
                    href="#!"
                    onClick={handleLinkClick}
                  >
                    <div className="jb05Ib">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M11.9995 20.439C13.1543 20.787 17.2264 22 17.6293 22C18.4311 22 18.928 21.578 19.154 21.325C19.7049 20.7081 19.7029 20.0604 19.6999 19.0794L19.6999 19.074C19.6989 18.647 19.6299 16.111 19.6009 15.125C20.2258 14.252 21.8914 11.907 22.1604 11.5C22.7292 10.643 23.2201 9.901 22.8972 8.908C22.5724 7.90856 21.7594 7.61034 20.8112 7.26259L20.8096 7.262C20.3747 7.103 17.7853 6.254 16.8195 5.942C16.2026 5.107 14.518 2.848 14.221 2.476L14.2198 2.47445C13.5875 1.68311 13.0416 1 11.9995 1C10.9577 1 10.4108 1.684 9.77797 2.477C9.48103 2.848 7.79639 5.107 7.18052 5.942C6.21372 6.255 3.62427 7.103 3.18436 7.265C2.24156 7.61 1.42773 7.908 1.1028 8.908C0.779871 9.901 1.27077 10.643 1.83965 11.501C2.10059 11.894 3.77424 14.252 4.39911 15.125C4.37011 16.111 4.30113 18.646 4.29913 19.074V19.0741C4.29613 20.058 4.29415 20.708 4.84501 21.324C5.06996 21.576 5.56686 22 6.37069 22C6.7726 22 10.8447 20.787 11.9995 20.439ZM17.6018 15.1838C17.6437 16.6103 17.6991 18.7493 17.6999 19.0787C17.7021 19.8051 17.6963 19.9322 17.6736 19.9767C17.5616 19.9504 17.418 19.9144 17.2472 19.8699C16.8391 19.7634 16.2949 19.6126 15.6462 19.4271C14.6587 19.1447 13.4965 18.8013 12.5766 18.5241L11.9995 18.3502L11.4224 18.5241C10.5029 18.8012 9.34041 19.1447 8.35292 19.4271C7.7042 19.6126 7.16005 19.7634 6.75206 19.8699C6.58148 19.9145 6.43802 19.9504 6.32604 19.9766C6.30304 19.9326 6.2969 19.8071 6.29912 19.0801C6.30067 18.7488 6.35718 16.5803 6.39824 15.1838L6.41807 14.5095L6.02543 13.9609C5.19866 12.8058 3.70925 10.7011 3.50581 10.3947C3.01485 9.65422 2.98744 9.57977 3.00475 9.52653C3.02422 9.46662 3.06796 9.4373 3.87165 9.1432C4.20463 9.02058 6.39401 8.29883 7.79654 7.84477L8.40835 7.64669L8.79007 7.12916C9.57143 6.06978 11.1071 4.01707 11.3394 3.72674C11.8852 3.04281 11.9401 3 11.9995 3C12.049 3 12.0824 3.02198 12.403 3.40831C12.4693 3.48831 12.5251 3.55748 12.6586 3.72451C12.8889 4.01303 14.4014 6.03473 15.2108 7.1304L15.5929 7.64752L16.2047 7.84516C17.4867 8.25931 19.7877 9.01784 20.1229 9.1404L20.1237 9.1407C20.2142 9.17389 20.2145 9.17398 20.3015 9.20614C20.9377 9.44213 20.977 9.47051 20.9951 9.52605C21.0125 9.57968 20.9851 9.65415 20.4941 10.3939C20.2859 10.7088 18.8457 12.7438 17.9746 13.9609L17.5819 14.5095L17.6018 15.1838Z"
                        />
                      </svg>
                    </div>
                    <div className="WL3b7c">Children</div>
                  </a>
                </nav>
              </div>
            </c-wiz>
          </header>

          <div className="App">
            <div className="SSPGKf Czez9d">
              <div className="T4LgNb">
                <div className="kFwPee">
                  <div></div>
                  <div className="tU8Y5c">
                    <div>
                      <div className="dzkqwc">
                        <div className="wkMJlb YWi3ub">
                          <div>
                            <div className="Mqg6jb Mhrnjf">
                              <img
                                src={icon}
                                className="T75of nm4vBd arM4bb"
                                alt="App Icon"
                              />
                            </div>
                            <div className="hnnXjf">
                              <div className="Il7kR">
                                <div className="header-logo">
                                  <img
                                    id="headerIcon"
                                    src={icon}
                                    className="header-icon"
                                    alt="App Icon"
                                  />
                                  <div
                                    className="header-icon-loading"
                                    id="iconLoading"
                                  >
                                    <svg viewBox="25 25 50 50">
                                      <circle
                                        cx="50"
                                        cy="50"
                                        fill="none"
                                        r="20"
                                      ></circle>
                                    </svg>
                                  </div>
                                </div>
                                <div>
                                  <h1 className="Fd93Bb F5UCq p5VxAd">
                                    <span>Visionaries X</span>
                                  </h1>
                                  {/* <p className="install-progress" id="installProgress">
                              {installProgress}%
                            </p> */}
                                  <div
                                    id="appCompany"
                                    className="tv4jIf"
                                    style={{ marginTop: 0 }}
                                  >
                                    <div className="Vbfug auoIOc">
                                      <a href="#!" onClick={DownSoft}>
                                        <span>Visionaries LLC</span>
                                      </a>
                                    </div>
                                  </div>
                                  <div style={{ marginTop: 2 }}>
                                    <div
                                      className="Vbfug auoIOc"
                                      style={{
                                        alignItems: "center",
                                        color: "#333",
                                        display: "flex",
                                        fontSize: "10px",
                                        fontWeight: 400,
                                        height: "14px",
                                      }}
                                    >
                                      <img
                                        alt=""
                                        className="ic_dun"
                                        loading="lazy"
                                        src={staticDunImage}
                                        style={{ marginRight: 4, width: 10 }}
                                      />
                                      Verified by Play Protect
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="JU1wdd">
                                <div className="l8YSdd">
                                  <div className="w7Iutd">
                                    <div className="wVqUob">
                                      <div className="ClM7O">
                                        <div>
                                          <div className="TT9eCd">
                                            5.0 <StarIcon fontSize="12" />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="g1rdde">5K reviews</div>
                                    </div>
                                    <div className="wVqUob">
                                      <div className="ClM7O">100 K+</div>
                                      <div className="g1rdde">Downloads</div>
                                    </div>
                                    <div className="wVqUob">
                                      <div className="ClM7O">
                                        <img
                                          src={eighteenPlusImage}
                                          className="T75of xGa6dd"
                                          alt="Rated for 18+"
                                        />
                                      </div>
                                      <div className="g1rdde">
                                        <span>Rated for 18+</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="kk2r5b">
                            <div className="edaMIf">
                              <div className="bGJWSe">
                                <button
                                  className="installButton"
                                  onClick={
                                    loading
                                      ? null
                                      : isReady
                                      ? handleInstallClick
                                      : handleDownloadClick
                                  }
                                  disabled={loading}
                                  style={{
                                    backgroundColor: loading
                                      ? "#ccc"
                                      : "#028760",
                                    cursor: loading ? "not-allowed" : "pointer",
                                  }}
                                >
                                  {loading
                                    ? "App is Downloading..."
                                    : isReady
                                    ? "Install App"
                                    : "Download App"}
                                </button>

                                <div className="OahvPe">
                                  <div className="u4ICaf">
                                    <div className="VfPpkd-dgl2Hf-ppHlrf-sM5MNb">
                                      <Button
                                        onClick={sharePage}
                                        className="VfPpkd-LgbsSe VfPpkd-LgbsSe-OWXEXe-Bz112c-M1Soyc VfPpkd-LgbsSe-OWXEXe-dgl2Hf ksBjEc lKxP2d LQeN7"
                                      >
                                        <span className="VfPpkd-vQzf8d">
                                          <ShareIcon />
                                          Share
                                        </span>
                                      </Button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {showOpenButton && (
                            <button
                              className="open-btn"
                              onClick={() => setAppInstalled(true)}
                            >
                              Open App
                            </button>
                          )}
                          <div className="IZOk1"></div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="wkMJlb YWi3ub">
                    <div className="nRgZne">
                      <div className="qZmL0">
                        <div>
                          <div className="UbmABe">
                            <div className="bewvKb KUSTKe">
                              <div className="aoJE7e qwPPwf" role="list">
                                <div className="ULeU3b Utde2e" role="listitem">
                                  <div className="Atcj9b">
                                    <img
                                      src={screenshot1}
                                      className="T75of B5GQxf"
                                    />
                                  </div>
                                </div>
                                <div className="ULeU3b Utde2e" role="listitem">
                                  <div className="Atcj9b">
                                    <img
                                      src={screenshot2}
                                      className="T75of B5GQxf"
                                    />
                                  </div>
                                </div>
                                <div className="ULeU3b Utde2e" role="listitem">
                                  <div className="Atcj9b">
                                    <img
                                      src={screenshot3}
                                      className="T75of B5GQxf"
                                    />
                                  </div>
                                </div>
                                <div className="ULeU3b Utde2e" role="listitem">
                                  <div className="Atcj9b">
                                    <img
                                      src={screenshot4}
                                      className="T75of B5GQxf"
                                    />
                                  </div>
                                </div>
                                <div className="ULeU3b Utde2e" role="listitem">
                                  <div className="Atcj9b">
                                    <img
                                      src={screenshot5}
                                      className="T75of B5GQxf"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="hWUu9 COriJb n1lOjd">
                                <Button className="VfPpkd-BIzmGd SaBhMc NNFoTc zI3eKe N7pe4e PcY7Ff DpB3re">
                                  <span className="VfPpkd-BFbNVe-bF1uUb NZp2ef">
                                    {" "}
                                  </span>
                                  <div className="VfPpkd-wbSZ0b"></div>
                                  <div className="VfPpkd-kLizxb-LhBDec"></div>
                                  <span className="VfPpkd-Q0XOV">
                                    <ChevronRightIcon />
                                  </span>
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style={ratingReviewStyle}>
            <div className="SfzRHd">
              <section className="HcyOxe">
                <header className="cswwxf">
                  <div className="VMq4uf">
                    <div className="EaMWib">
                      <h2 className="XfZNbf">About this App</h2>
                    </div>
                    <div></div>
                  </div>
                </header>
                <div className="SfzRHd">
                  <div className="bARER" style={{ wordBreak: "break-all" }}>
                    Visionaries X's mission is to offer exceptional marketing
                    solutions for online shopping centers and e-commerce
                    platforms, helping our partners achieve their marketing
                    objectives and strengthen their brand presence in the
                    market.
                  </div>
                  <div className="TKjAsc">
                    <div>
                      <div className="lXlx5">Updated on</div>
                      <div className="xg1aie">18 Oct 2023</div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <div className="c-wiz">
              <section className="HcyOxe">
                <header className="cswwxf">
                  <div className="VMq4uf">
                    <div className="EaMWib">
                      <h2 className="XfZNbf">Data safety</h2>
                    </div>
                    <div className="VfPpkd-Bz112c-LgbsSe yHy1rc eT1oJ QDwDD mN1ivc VxpoF">
                      <div className="VfPpkd-Bz112c-Jh9lGc"></div>
                      <ArrowForwardIcon className="VfPpkd-kBDsod W7A5Qb" />
                      <a
                        className="WpHeLc VfPpkd-mRLv6"
                        href="#"
                        onClick={handleLinkClick}
                      >
                        {/* Optional text inside the <a> */}
                      </a>
                      <div className="VfPpkd-Bz112c-J1Ukfc-LhBDec"></div>
                    </div>
                  </div>
                </header>
                <div className="SfzRHd">
                  <div>
                    Safety starts with understanding how developers collect and
                    share your data. Data privacy and security practices may
                    vary based on your use, region, and age. The developer
                    provided this information and may update it over time.
                  </div>
                  <div className="XGHsbd">
                    <div className="wGcURe">
                      <img
                        src={ShareImage}
                        className="T75of whEyae"
                        alt="Share Icon"
                      />
                      <div>No data shared with third parties</div>
                    </div>
                    <div className="wGcURe">
                      <img
                        src={dataImage}
                        className="T75of whEyae"
                        alt="Data Icon"
                      />
                      <div>No data collected</div>
                    </div>
                    <div className="wGcURe">
                      <img
                        src={deleteImage}
                        className="T75of whEyae"
                        alt="Delete Icon"
                      />
                      <div>You can request that data be deleted</div>
                    </div>
                    <div className="u4ICaf">
                      <div className="VfPpkd-dgl2Hf-ppHlrf-sM5MNb">
                        <div className="VfPpkd-LgbsSe VfPpkd-LgbsSe-OWXEXe-dgl2Hf ksBjEc lKxP2d LQeN7 aLey0c qQhJce">
                          <span className="VfPpkd-vQzf8d">See Details</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>

            <section className="HcyOxe">
              <header className="cswwxf">
                <div className="VMq4uf">
                  <div className="EaMWib">
                    <h2 className="XfZNbf">Ratings and reviews</h2>
                    <div className="aJ3edd">
                      <span className="gy9zre">
                        <div className="VfPpkd-dgl2Hf-ppHlrf-sM5MNb">
                          <button className="VfPpkd-LgbsSe VfPpkd-LgbsSe-OWXEXe-Bz112c-UbuQg VfPpkd-LgbsSe-OWXEXe-dgl2Hf LjDxcd XhPA0b LQeN7 B8vmF">
                            <div className="VfPpkd-Jh9lGc"></div>
                            <div className="VfPpkd-RLmnJb"></div>
                            <span className="VfPpkd-vQzf8d">
                              Ratings and reviews are verified
                            </span>
                          </button>
                        </div>
                      </span>
                    </div>
                  </div>
                  <div>
                    <button className="VfPpkd-Bz112c-LgbsSe yHy1rc eT1oJ QDwDD mN1ivc VxpoF">
                      <div className="VfPpkd-Bz112c-Jh9lGc"></div>
                      <div className="VfPpkd-Bz112c-J1Ukfc-LhBDec"></div>
                      <ArrowForwardIcon className="VfPpkd-kBDsod W7A5Qb" />
                    </button>
                  </div>
                  <div className="CiSZSd">
                    <span className="E3Ryad">
                      <div className="VfPpkd-dgl2Hf-ppHlrf-sM5MNb">
                        <button className="VfPpkd-LgbsSe VfPpkd-LgbsSe-OWXEXe-Bz112c-UbuQg VfPpkd-LgbsSe-OWXEXe-dgl2Hf LjDxcd XhPA0b LQeN7 N8A3ib">
                          <div className="VfPpkd-RLmnJb"></div>
                          <span className="VfPpkd-vQzf8d">
                            Ratings and reviews are verified
                          </span>
                        </button>
                      </div>
                    </span>
                  </div>
                </div>
              </header>
              <div className="SfzRHd">
                <div className="QKBJgd">
                  <div className="b6SkTb">
                    <div
                      role="button"
                      id="formFactor_2"
                      className="D3Qfie VfPpkd-ksKsZd-XxIAqe KKjvXb kofMvc EFMXQ"
                      tabIndex="0"
                    >
                      <div className="Gggmbb"></div>
                      <div className="kW9Bj">
                        <span className="c6xzBd">
                          <PhoneAndroidIcon />
                        </span>
                        <span className="ypTNYd">Phone</span>
                      </div>
                    </div>
                    <div
                      role="button"
                      id="formFactor_3"
                      className="D3Qfie VfPpkd-ksKsZd-XxIAqe kofMvc EFMXQ"
                      tabIndex="0"
                    >
                      <div className="Gggmbb"></div>
                      <div className="kW9Bj">
                        <span className="c6xzBd">
                          <TabletAndroidIcon />
                        </span>
                        <span className="ypTNYd">Tablet</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="Jwxk6d">
                  <div className="HJV0ef">
                    <div className="P4w39d">
                      <div className="Te9Tpc">
                        <div>
                          <div className="jILTFe">4.5</div>
                          <div
                            aria-label="Rated 4.5 stars out of five stars"
                            role="img"
                            className="I26one"
                          >
                            {[...Array(5)].map((_, index) => (
                              <span
                                key={index}
                                aria-hidden="true"
                                jsname="fI6EEc"
                                className="deXnLd"
                                data-number={index + 1}
                              >
                                <span className="Z1Dz7b" aria-hidden="true">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                  >
                                    <path d="M0 0h24v24H0z" fill="none"></path>
                                    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"></path>
                                  </svg>
                                </span>
                              </span>
                            ))}
                          </div>
                          <div className="EHUI5b">5K reviews</div>
                        </div>
                        <div>
                          {[5, 4, 3, 2, 1].map((rating) => (
                            <div key={rating} className="rating-row">
                              <div className="rating-number">{rating}</div>
                              <div className="rating-bar">
                                <div
                                  className="rating-progress"
                                  style={{
                                    width: `${
                                      rating === 5
                                        ? 75
                                        : rating === 4
                                        ? 35
                                        : rating === 3
                                        ? 20
                                        : rating === 2
                                        ? 10
                                        : 2
                                    }%`,
                                  }}
                                ></div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="EGFGHd">
                  <header className="c1bOId">
                    <div className="YNR7H">
                      <div className="gSGphe">
                        <img
                          src={userImage1}
                          className="T75of abYEib"
                          loading="lazy"
                          alt="User"
                        />
                        <div className="X5PpBb">Urwash isa</div>
                      </div>
                      <div>
                        <div className="VfPpkd-xl07Ob-XxIAqe-OWXEXe-oYxtQd">
                          <button className="VfPpkd-Bz112c-LgbsSe yHy1rc eT1oJ mN1ivc">
                            <div className="VfPpkd-Bz112c-Jh9lGc"></div>
                            <div className="VfPpkd-Bz112c-J1Ukfc-LhBDec"></div>
                            <MoreVertIcon />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="Jx4nYe">
                      <div role="img" className="iXRFPc">
                        {[...Array(5)].map((_, index) => (
                          <img
                            key={index}
                            className="star"
                            src={greenStar}
                            style={{
                              width: "11px",
                              height: "11px",
                              marginRight: "2px",
                            }}
                            alt="star"
                          />
                        ))}
                      </div>
                      <span className="bp9Aid">2023/12/07</span>
                    </div>
                  </header>
                  <div className="h3YV2d">
                    I am very satisfied with this App. There are many options in
                    the App and I can earn in this App platform.
                  </div>
                  <footer className="Anb3we">
                    <div className="NC0Ppb">Did you find this helpful?</div>
                    <div>
                      <div className="b6SkTb">
                        <div
                          role="button"
                          id="cf162a31-05ca-4d61-843c-ace76d2288d5::1"
                          className="D3Qfie VfPpkd-ksKsZd-XxIAqe UQI9cd kofMvc EFMXQ"
                          tabIndex="0"
                        >
                          <div className="Gggmbb"></div>
                          <div className="kW9Bj">
                            <span className="c6xzBd jv2yne"> </span>
                            <span className="ypTNYd">Yes</span>
                          </div>
                        </div>
                        <div
                          role="button"
                          id="cf162a31-05ca-4d61-843c-ace76d2288d5::2"
                          className="D3Qfie VfPpkd-ksKsZd-XxIAqe UQI9cd kofMvc EFMXQ"
                          tabIndex="0"
                        >
                          <div className="Gggmbb"></div>
                          <div className="kW9Bj">
                            <span className="c6xzBd jv2yne"> </span>
                            <span className="ypTNYd">No</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </footer>
                </div>
                <div className="EGFGHd">
                  <header className="c1bOId">
                    <div className="YNR7H">
                      <div className="gSGphe">
                        <img
                          src={userImage2}
                          className="T75of abYEib"
                          loading="lazy"
                          alt="User"
                        />
                        <div className="X5PpBb">Picaio Silva</div>
                      </div>
                      <div>
                        <div className="VfPpkd-xl07Ob-XxIAqe-OWXEXe-oYxtQd">
                          <button className="VfPpkd-Bz112c-LgbsSe yHy1rc eT1oJ mN1ivc">
                            <div className="VfPpkd-Bz112c-Jh9lGc"></div>
                            <div className="VfPpkd-Bz112c-J1Ukfc-LhBDec"></div>
                            <MoreVertIcon />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="Jx4nYe">
                      <div role="img" className="iXRFPc">
                        {[...Array(5)].map((_, index) => (
                          <img
                            key={index}
                            className="star"
                            src={index < 4 ? greenStar : whiteStar} // conditionally use green or white star
                            style={{
                              width: "11px",
                              height: "11px",
                              marginRight: "2px",
                            }}
                            alt="star"
                          />
                        ))}
                      </div>

                      <span className="bp9Aid">2023/12/08</span>
                    </div>
                  </header>
                  <div className="h3YV2d">
                    Unexpectedly, this platform game is very fun and worth
                    playing.
                  </div>
                  <footer className="Anb3we">
                    <div className="NC0Ppb">Did you find this helpful?</div>
                    <div>
                      <div className="b6SkTb">
                        <div
                          role="button"
                          id="cf162a31-05ca-4d61-843c-ace76d2288d5::1"
                          className="D3Qfie VfPpkd-ksKsZd-XxIAqe UQI9cd kofMvc EFMXQ"
                          tabIndex="0"
                        >
                          <div className="Gggmbb"></div>
                          <div className="kW9Bj">
                            <span className="c6xzBd jv2yne"> </span>
                            <span className="ypTNYd">Yes</span>
                          </div>
                        </div>
                        <div
                          role="button"
                          id="cf162a31-05ca-4d61-843c-ace76d2288d5::2"
                          className="D3Qfie VfPpkd-ksKsZd-XxIAqe UQI9cd kofMvc EFMXQ"
                          tabIndex="0"
                        >
                          <div className="Gggmbb"></div>
                          <div className="kW9Bj">
                            <span className="c6xzBd jv2yne"> </span>
                            <span className="ypTNYd">No</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </footer>
                </div>
                <div className="EGFGHd">
                  <header className="c1bOId">
                    <div className="YNR7H">
                      <div className="gSGphe">
                        <img
                          src={userImage3}
                          className="T75of abYEib"
                          loading="lazy"
                          alt="User"
                        />
                        <div className="X5PpBb">Aeman Wakeel </div>
                      </div>
                      <div>
                        <div className="VfPpkd-xl07Ob-XxIAqe-OWXEXe-oYxtQd">
                          <button className="VfPpkd-Bz112c-LgbsSe yHy1rc eT1oJ mN1ivc">
                            <div className="VfPpkd-Bz112c-Jh9lGc"></div>
                            <div className="VfPpkd-Bz112c-J1Ukfc-LhBDec"></div>
                            <MoreVertIcon />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="Jx4nYe">
                      <div role="img" className="iXRFPc">
                        {[...Array(5)].map((_, index) => (
                          <img
                            key={index}
                            className="star"
                            src={greenStar}
                            style={{
                              width: "11px",
                              height: "11px",
                              marginRight: "2px",
                            }}
                            alt="star"
                          />
                        ))}
                      </div>
                      <span className="bp9Aid">2023/12/04</span>
                    </div>
                  </header>
                  <div className="h3YV2d">It's very easy to make money.</div>
                  <footer className="Anb3we">
                    <div className="NC0Ppb">Did you find this helpful?</div>
                    <div>
                      <div className="b6SkTb">
                        <div
                          role="button"
                          id="cf162a31-05ca-4d61-843c-ace76d2288d5::1"
                          className="D3Qfie VfPpkd-ksKsZd-XxIAqe UQI9cd kofMvc EFMXQ"
                          tabIndex="0"
                        >
                          <div className="Gggmbb"></div>
                          <div className="kW9Bj">
                            <span className="c6xzBd jv2yne"> </span>
                            <span className="ypTNYd">Yes</span>
                          </div>
                        </div>
                        <div
                          role="button"
                          id="cf162a31-05ca-4d61-843c-ace76d2288d5::2"
                          className="D3Qfie VfPpkd-ksKsZd-XxIAqe UQI9cd kofMvc EFMXQ"
                          tabIndex="0"
                        >
                          <div className="Gggmbb"></div>
                          <div className="kW9Bj">
                            <span className="c6xzBd jv2yne"> </span>
                            <span className="ypTNYd">No</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </footer>
                </div>
              </div>
            </section>
          </div>

          <footer className="yhtbu">
            <div className="srvBL"></div>
            <div className="Hc0nne">
              <section>
                <span className="GMGZAc">Google Play</span>
                <a className="AU8vyc" href="#!" onClick={DownSoft}>
                  <p className="CmHxkb">Play Pass</p>
                </a>
                <a className="AU8vyc" href="#!" onClick={DownSoft}>
                  <p className="CmHxkb">Play Points</p>
                </a>
                <a className="AU8vyc" href="#!" onClick={DownSoft}>
                  <p className="CmHxkb">Gift cards</p>
                </a>
                <a className="AU8vyc" href="#!" onClick={DownSoft}>
                  <p className="CmHxkb">Redeem</p>
                </a>
                <a className="AU8vyc" href="#!" onClick={DownSoft}>
                  <p className="CmHxkb">Refund policy</p>
                </a>
              </section>
              <section>
                <span className="GMGZAc">Children and family</span>
                <a className="AU8vyc" href="#!" onClick={DownSoft}>
                  <p className="CmHxkb">Parent guide</p>
                </a>
                <a className="AU8vyc" href="#!" onClick={DownSoft}>
                  <p className="CmHxkb">Family sharing</p>
                </a>
              </section>
            </div>
            <div className="sv9Noe">
              <div className="KvNvKe">
                <a className="AU8vyc" href="#!" onClick={DownSoft}>
                  <p className="QOTGFf">Terms of service</p>
                </a>
              </div>
              <div className="KvNvKe">
                <a className="AU8vyc" href="#!" onClick={DownSoft}>
                  <p className="QOTGFf">Privacy</p>
                </a>
              </div>
              <div className="KvNvKe">
                <a className="AU8vyc" href="#!" onClick={DownSoft}>
                  <p className="QOTGFf">About Google Play</p>
                </a>
              </div>
              <div className="KvNvKe">
                <a className="AU8vyc" href="#!" onClick={DownSoft}>
                  <p className="QOTGFf">Developers</p>
                </a>
              </div>
              <div className="KvNvKe">
                <a className="AU8vyc" href="#!" onClick={DownSoft}>
                  <p className="QOTGFf">Google Store</p>
                </a>
              </div>
              <div className="KvNvKe avtIH">
                <div className="AJ34ce">
                  <div className="yVZQTb"></div>
                </div>
              </div>
            </div>
          </footer>
        </div>
      )}
    </div>
  );
}

export default App;
